import { HeaderContainer } from '../header';
import React from 'react';
import { MainHeader } from 'telia-front-react';
import { isMyTeliaUserAgent } from '../utils';
import HeaderRootStore from './store/HeaderRootStore';
import mergeHeaderState from './util/HeaderStateMergeUtil';
let rootStore;
const AppHeader = (props) => {
    if (rootStore === undefined || props.isSSR) {
        rootStore = new HeaderRootStore(props);
    }
    else {
        React.useEffect(() => mergeHeaderState(rootStore, props));
    }
    if (isMyTeliaUserAgent()) {
        return null;
    }
    return (React.createElement(MainHeader, null,
        React.createElement(HeaderContainer, { rootStore: rootStore })));
};
export default AppHeader;
//# sourceMappingURL=AppHeader.js.map